/**
 * Created by xnr on 2020-03-31.
 */
import request from "../utils/fetch";
//获取当前登录用户信息
export function customerinfo(data) {
  return request({
    url: "/admin/customer/info",
    method: "get",
    requestBody: "null",
    loading: true,
    params: data,
  });
}

export function findPassword(data) {
  return request({
    url: "/admin/customer/findPassword",
    method: "post",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function getCustomerInfo(data) {
  return request({
    url: "/admin/customer/getCustomerInfo",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//修改昵称
export function updateNickName(data) {
  return request({
    url: "/admin/customer/updateNickName",
    method: "get",
    requestBody: "null",
    loading: true,
    params: data,
  });
}
export function updateAdminCustomerFace(data) {
  return request({
    url: "/admin/customer/updateAdminCustomerFace",
    method: "get",
    requestBody: "null",
    loading: true,
    params: data,
  });
}

export function updatePassword(data) {
  return request({
    url: "/admin/customer/updatePassword",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//用户名密码登录
export function customerlogin(data) {
  return request({
    url: "/user/company/login",
    method: "post",
    requestBody: "body",
    // 登录页需要根据验证码失效等具体原因自行处理。
    skipGlobalError: true,
    loading: true,
    data: data,
  });
}
//用户名密码注册
export function customerregister(data) {
  return request({
    url: "/admin/customer/register",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//用户操作退出登录
export function customerlogout(data) {
  return request({
    url: "/admin/customer/logout",
    method: "post",
    requestBody: "null",
    loading: true,
    data: data,
  });
}

//新增系统用户
export function customeradd(data) {
  return request({
    url: "/admin/customer/add",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//修改系统用户角色
export function customerupdate(data) {
  return request({
    url: "/admin/customer/update",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//获取管理用户列表
export function customermanagerList(data) {
  return request({
    url: "/admin/customer/managerList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
//修改指定用户状态
export function customerupdateStatus(data) {
  return request({
    url: "/admin/customer/updateStatus",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
export function getadmininfo(data) {
  return request({
    url: "/admin/customer/testinfo",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 修改头像，修改密码，修改昵称
export function updateNameORPwdORHeader(data) {
  return request({
    url: "/user/sys/company/customer/user/update/info",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 用户删除
export function delUser(data) {
  return request({
    url: "/user/sys/company/customer/delUser",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
